import React, { useLayoutEffect } from "react";
import AuthContainer from "../components/AuthContainer/AuthContainer";
import Typography from "../components/Typography/Typography";
import Emma from "../assets/images/Illustration.png";
import Button from "../components/Button/Button";
import { Link } from "react-router-dom";
import GridLGHidden from "../components/GridComponent/components/GridLGHidden";
import TextLogo from "../assets/images/talkpal-text-logo.svg";
import GridSMHidden from "../components/GridComponent/components/GridSMHidden";
import Divider from "../components/Divider/Divider";

const StartPage = () => {
  useLayoutEffect(() => {
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    metaThemeColor && metaThemeColor.setAttribute("content", "#FFFFFF");
  }, []);

  return (
    <AuthContainer>
      <div className="flex min-h-svh  lg:h-full lg:w-full items-center justify-center max-lg:w-screen ">
        <div className=" bg-[url(/src/assets/images/Background.png)] bg-cover bg-center w-full hide-scrollbar min-h-svh lg:min-h-[10%] max-lg:bg-white  bg-light-blue lg:rounded-20 lg:max-h-90% relative flex h-full flex-col items-center overflow-x-hidden lg:h-auto lg:overflow-y-auto  lg:bg-white lg:p-24 lg:gap-24 ">
          <GridLGHidden>
            <img src={TextLogo} alt="" className="absolute left-16 top-20" />
          </GridLGHidden>

          <div className="flex flex-col max-lg:flex-col-reverse my-32 flex-1 justify-center">
            <div>
              <Typography
                as="h1"
                type="Header2"
                className="text-center !font-medium mb-24 max-lg:px-32"
              >
                Talkpal for organizations
              </Typography>
              <Typography
                type="Body"
                typeSM="Body2"
                className="!text-[#868686] text-center px-36 max-lg:px-12"
              >
                Provide your organization with an easy access to AI-powered
                digital language learning.{" "}
              </Typography>
            </div>
            <div className="max-h-[40%] lg:h-auto flex justify-center items-end lg:flex-col lg:items-center w-full">
              <div className="h-5/6 lg:h-auto overflow-hidden">
                <img
                  src={Emma}
                  className="h-full lg:relative  w-[215px] mt-32 max-lg:mb-32"
                  alt=""
                />
              </div>
            </div>
          </div>

          <div className="w-full flex flex-col  px-12 lg:px-0 pb-24 lg:pb-0">
            <Link to={"/signup"} className="mb-12">
              <Button
                buttonType="primary"
                title={"Get started"}
                testID="get-started"
              />
            </Link>
            <Link to={"/login"}>
              <Button
                buttonType="secondary"
                title={"Log in"}
                testID="login-onboarding"
              />
            </Link>
            <GridSMHidden>
              <Divider className="w-full" />
            </GridSMHidden>
            <Link
              to={"https://talkpal.ai/"}
              target="_blank"
              className="max-lg:mt-[20px] group"
            >
              <Typography
                type="Body2"
                className="text-dark-grey-5 mb-12 text-center underline underline-offset-4 lg:mb-0 group-hover:text-[#282828cc]"
              >
                {" "}
                © Talkpal, Inc.
              </Typography>
            </Link>
          </div>
        </div>
      </div>
    </AuthContainer>
  );
};

export default StartPage;
